export default __webpack_public_path__ + "static/media/Conduit_ITC.548a0954.ttf";